import Hero from "@/components/site/Hero";
import HomePhilosophy from "@/components/site/HomePhilosophy";
import HomeProjectsTeaser from "@/components/site/HomeProjectsTeaser";

export default function HomePage() {
  return (
    <>
      <Hero />
      <HomePhilosophy />
      <HomeProjectsTeaser />
    </>
  );
}
